import gsap from 'gsap';

import MorphSVGPlugin from '../../../lib/morphSvg';
import SplitText from '../../../lib/SplitToText';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollTo from 'gsap/ScrollToPlugin';

import createFirstTimeline from './scrollIn';

function createJobsToBeDoneAnimation({
  mainElementTriggerRef,
  rightColumnRef,
  leftTextColumnRef,
  setIsFirstTimelineCompleted,
}) {
  gsap.registerPlugin(MorphSVGPlugin, SplitText, ScrollTrigger, ScrollTo);

  let firstTil = createFirstTimeline({
    mainElementTriggerRef,
    rightColumnRef,
    leftTextColumnRef,
    setIsFirstTimelineCompleted,
  });

  return [firstTil];
}

//  @FURTHER
// function fadeInRightColumn(rightColumnRef) {
//   let tl = gsap.timeline();

//   return tl.to(rightColumnRef.current, {
//     y: `-50%`,
//     opacity: 1,
//     transformOrigin: 'center',
//     duration: 0.5,
//     ease: Power0.easeOut,
//   });
// }

// function animateFistPath(tl, initialPath) {
//   return tl.to(initialPath.current, {
//     rotate: -45,
//     x: 0,
//     scale: 1.2,
//     y: 7,
//     delay: 0.1,
//     transformOrigin: 'center',
//     duration: 0.2,
//     ease: Power0.easeInOut,
//   });
// }

// function animateSecondPath(tl, initialPath) {
//   return tl.to(
//     initialPath.current,
//     {
//       rotate: 45,
//       scale: 1.2,
//       x: 0,
//       y: 0,
//       transformOrigin: 'center',
//       duration: 0.2,
//       ease: Power0.easeInOut,
//     },
//     '<',
//   );
// }

// function morphPath(tl, initialPath, forwardPath, index) {
//   MorphSVGPlugin.convertToPath(`#${initialPath.current.id}`);
//   MorphSVGPlugin.convertToPath(`#${forwardPath.current.id}`);

//   return tl.to(
//     `#${initialPath.current.id}`,
//     {
//       rotate: !index ? -45 : 45,
//       x: index ? -4 : 2,
//       y: !index ? 0 : 6,
//       scale: !index ? 1 : 1.2,
//       transformOrigin: "center",
//       duration: 2,
//       ease: Power0.easeInOut,
//     },
//     "-=1"
//   );
// }

// function fadeOutExtraPath(extraPath) {
//   let tl = gsap.timeline({
//     id: `fadeOutExtraPath`,
//     delay: 0,
//     repeatDelay: 0,
//   });

//   return tl.to(
//     extraPath.current,
//     {
//       duration: 0.2,
//       opacity: 0,
//       ease: 'ease-in-out',
//       y: 2,
//     },
//     '-=1',
//   );
// }

export default createJobsToBeDoneAnimation;
